import { RestTrack, TracksReloadJobState } from '@/types'
import { sleep } from '@/utils/sleep'

const mockData: RestTrack[] = [
  {
    name: 'In Your Eyes',
    artist_name: 'BADBADNOTGOOD',
    album_name: 'IV',
    release_date: '2016-07-08',
    preview_url: 'https://p.scdn.co/mp3-preview/ff8d538fce79bb78a759a7d8be04679493914a81?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    spotify_id: '1Xm0HkaGqf0LDouD9Qmo2X',
    album_spotify_id: '6R7CVG0kOF7h0NLg10ezpZ',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 0,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 75
  },
  {
    name: 'WEIGHT OFF',
    artist_name: 'KAYTRANADA',
    album_name: '99.9%',
    release_date: '2016-05-06',
    preview_url: 'https://p.scdn.co/mp3-preview/33711c75cf71cf098c67ec0709f8fb593eec6d53?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2733016bbbbdf0825d3e4dc9aee'
      },
    ],
    spotify_id: '12s6FjStmOwWJrh0yalbKC',
    album_spotify_id: '6JD4Qerb8IcaAzFgpFw0sa',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 1,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 76
  },
  {
    name: 'Hedron',
    artist_name: 'BADBADNOTGOOD',
    album_name: 'Late Night Tales: Bonobo',
    release_date: '2013-11-17',
    preview_url: 'https://p.scdn.co/mp3-preview/a5dc09b0071b2bb8476cc0dd18ef9b9a8135e260?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273848936ba27cbea380a7a8d73'
      },
    ],
    spotify_id: '10lGufP5RmCsUwKDTcPpxs',
    album_spotify_id: '75mOIzgjMsFLN5hyQlpsy8',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 2,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 77
  },
  {
    name: 'Confessions',
    artist_name: 'BADBADNOTGOOD',
    album_name: 'III',
    release_date: '2014-05-05',
    preview_url: 'https://p.scdn.co/mp3-preview/233b50ade8bdc236bf3c9cec1d242acc423a4148?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273f20f6e0d61ed79a454d1a57e'
      },
    ],
    spotify_id: '7FzhTFnLBv0hh5n95CfejY',
    album_spotify_id: '6VqtrhGLO1qRTjqRow5NG1',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 3,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 78
  },
  {
    name: 'Time Moves Slow',
    artist_name: 'BADBADNOTGOOD',
    album_name: 'IV',
    release_date: '2016-07-08',
    preview_url: 'https://p.scdn.co/mp3-preview/23b263767f0a5c2f2741b517fd2e06c8931435ee?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    spotify_id: '4eVUPMhqGFcmxo6cjv9KqA',
    album_spotify_id: '6R7CVG0kOF7h0NLg10ezpZ',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 4,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 79
  },
  {
    name: 'King of the Hill',
    artist_name: 'Thundercat',
    album_name: 'King of the Hill',
    release_date: '2018-10-30',
    preview_url: 'https://p.scdn.co/mp3-preview/da81d48e62689d0b46ad92c9eb1a33e7d68c2421?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273ac050843ffb580d88d2b3a4e'
      },
    ],
    spotify_id: '3aLN90hPetcE1YjQQ0cbBg',
    album_spotify_id: '2RMJyJJlmJubpqFotHHQAy',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 5,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 80
  },
  {
    name: 'Goodbye Blue',
    artist_name: 'BADBADNOTGOOD',
    album_name: 'Goodbye Blue',
    release_date: '2020-04-28',
    preview_url: 'https://p.scdn.co/mp3-preview/dd6a1fbe97b227ef5e25cfc92cc656297ac83255?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2738bea03f830d70a4abc8ea055'
      },
    ],
    spotify_id: '1Hl4xRC4328EyH1cgmpacP',
    album_spotify_id: '7DEVGpxtcFj3fCLk9kc8Ro',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 6,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 81
  },
  {
    name: 'Paradise (feat. Badbadnotgood & Sean Leon)',
    artist_name: 'Daniel Caesar',
    album_name: "Pilgrim's Paradise",
    release_date: '2015-11-12',
    preview_url: 'https://p.scdn.co/mp3-preview/46966c6b960eb140402d32457e5d8f0a3a0ad8ab?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273a117ac19ee51aebdf05fe88c'
      },
    ],
    spotify_id: '5bPZPEsUACrQXER6FcMs7F',
    album_spotify_id: '4uP43hIpmEEDuW7aOfiU2C',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 7,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 82
  },
  {
    name: 'Sour Soul',
    artist_name: 'BADBADNOTGOOD',
    album_name: 'Sour Soul',
    release_date: '2015-02-19',
    preview_url: 'https://p.scdn.co/mp3-preview/d0effd1b65a81138672ac6030ce5f5d270b38e09?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273aed7d31cdd487e9974f591d8'
      },
    ],
    spotify_id: '48mJsuV6IsDVrjkhqR2mHG',
    album_spotify_id: '7gP4vkln7Qmbycgx8WwTzL',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 8,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 83
  },
  {
    name: 'Key to Love (Is Understanding)',
    artist_name: 'BADBADNOTGOOD',
    album_name: 'Key to Love (Is Understanding)',
    release_date: '2019-12-06',
    preview_url: 'https://p.scdn.co/mp3-preview/d7a0bbf9a1ad19cb2c6e35f95bdadc3d39485ffb?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2735e298b8b0df40150638e471b'
      },
    ],
    spotify_id: '6TbsXTCa3lwOWJLGul2mwF',
    album_spotify_id: '2KnFwNju5oOgOrBq5tkYJA',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 9,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 84
  },
  {
    name: 'Lavender',
    artist_name: 'BADBADNOTGOOD',
    album_name: 'IV',
    release_date: '2016-07-08',
    preview_url: 'https://p.scdn.co/mp3-preview/f277a890b12ada872ab6785b063295c3d295484c?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    spotify_id: '6iPEiWr7OSz8qyu9wJPOtX',
    album_spotify_id: '6R7CVG0kOF7h0NLg10ezpZ',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 10,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 85
  },
  {
    name: 'Smoking Song',
    artist_name: 'Mick Jenkins',
    album_name: 'Pieces of a Man',
    release_date: '2018-10-26',
    preview_url: 'https://p.scdn.co/mp3-preview/50a3796a3c46cf51ad8df0ce429f75d795eed49d?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b27397735761179f880b86c6031e'
      },
    ],
    spotify_id: '2sRXqik5815qTwe6c6Qmfu',
    album_spotify_id: '2YUoojiwp6nk5mBAUbEz9a',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 11,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 86
  },
  {
    name: 'And the Beat Goes On',
    artist_name: 'The Whispers',
    album_name: 'The Whispers / Happy Holidays to You',
    release_date: '1979-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/3bc33cc685c50a8ef0645539ed6819b4d957bbd5?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273408c6751331cf3f40efb0c05'
      },
    ],
    spotify_id: '5rc28C9Ym7zIAypx3QGcnv',
    album_spotify_id: '17Rg4iNDr5gncTwj8zTvUo',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 12,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 87
  },
  {
    name: "It's A Love Thing",
    artist_name: 'The Whispers',
    album_name: 'The Complete Solar Hit Singles Collection',
    release_date: '2014-09-08',
    preview_url: 'https://p.scdn.co/mp3-preview/c8ffbe3b809a6f0080089cd8781a6e25784d6394?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273207ef153baf3aad77dc9da3c'
      },
    ],
    spotify_id: '2BNCRJ4rAoPtdIOIPCiJIY',
    album_spotify_id: '5BAfhvuiUfuxrVUHfF00SB',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 13,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 88
  },
  {
    name: "Keep On Lovin' Me",
    artist_name: 'The Whispers',
    album_name: 'Love for Love',
    release_date: '1983-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/e3d79a619e5ee7561491016e3d663382687c9e2d?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2735f6a479e5b7e7bfa9113e23a'
      },
    ],
    spotify_id: '1rTVcF2lyMET3NLQJlHWkr',
    album_spotify_id: '2IUANeaZQ74WmiisC0ffTX',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 14,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 89
  },
  {
    name: 'As I Sit Here',
    artist_name: 'The Whispers',
    album_name: "The Dore 60's Singles (Digitally Remastered)",
    release_date: '2010-10-19',
    preview_url: 'https://p.scdn.co/mp3-preview/f1af081eee707093eb16b62aea77ca438a866754?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2738e027b9e494409dc3d91dc41'
      },
    ],
    spotify_id: '4g3FPh3nIDC75dTrSNTiTf',
    album_spotify_id: '68GXgnUP5RCCa6xa5exTSa',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 15,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 90
  },
  {
    name: 'Say Yes',
    artist_name: 'The Whispers',
    album_name: 'Best Slow Jams - Volume One',
    release_date: '2008-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/7d78fd2352c51839b5253d3d969f2d28c22612e9?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2738d1a554d25761f549ba752a5'
      },
    ],
    spotify_id: '1u1huPPgeJRiPpQxQsyoLU',
    album_spotify_id: '5KIiwl8O0yoyARKkBhtt76',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 16,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 91
  },
  {
    name: 'Is It Good To You',
    artist_name: 'The Whispers',
    album_name: 'More Of The Night',
    release_date: '1990-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/af87f5c4e2337d6cb88ef78abfc629f26829f7ef?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273dfc40ced58b0fceeff36eced'
      },
    ],
    spotify_id: '6GxuxSi6IZLoEVdOTITdvZ',
    album_spotify_id: '3m6teYhTYkU2emsaNzaQOC',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 17,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 92
  },
  {
    name: 'Keep On Loving Me',
    artist_name: 'The Whispers',
    album_name: 'And the Beat Goes On',
    release_date: '1999-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/161791960d5a5f5ba63c4e61b69c3b48a602624b?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b273abe6306c78e0da0a25f2327c'
      },
    ],
    spotify_id: '6DvuWcpLYss7raEMSSguaY',
    album_spotify_id: '4HwMD8JSkdWOxc3AIbETUL',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 18,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 93
  },
  {
    name: "I'm Gonna Make You My Wife",
    artist_name: 'The Whispers',
    album_name: 'Best Slow Jams - Volume One',
    release_date: '2008-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/adc45c473758324726521b49095dc6294af2cc98?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2738d1a554d25761f549ba752a5'
      },
    ],
    spotify_id: '2F114CupPJYKWI42OLj4V8',
    album_spotify_id: '5KIiwl8O0yoyARKkBhtt76',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 19,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 94
  },
  {
    name: 'Are You Going My Way',
    artist_name: 'The Whispers',
    album_name: 'Best Slow Jams - Volume One',
    release_date: '2008-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/e1594d71a4de99f931ad630060ae2b2c1b3de106?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2738d1a554d25761f549ba752a5'
      },
    ],
    spotify_id: '1mjPrVaQBfLAmNfw43fVOW',
    album_spotify_id: '5KIiwl8O0yoyARKkBhtt76',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 20,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 95
  },
  {
    name: 'This Strange Affair',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/108b9e4ad842c37d23ddcc7bb03f082e1a113434?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '6hkJHlMlAZM48glfJbCSWs',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 21,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 96
  },
  {
    name: 'Raining In London',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/c234921f0a604a971ee7324834df7627684e59ef?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '2wchoSXJ9VA613uZBSWS64',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 22,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 97
  },
  {
    name: 'Sequence Of Thought',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/d9004710c6dfb6ad665e5cc94f5bca148633eb49?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '2ufEZtOiY5FmHFKYj0KsEQ',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 23,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 98
  },
  {
    name: 'Did She',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/eb63b54565de9f18693a0a9c534c142b5740a4e1?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '6mVcXfIDKvucNkKTc4WRF9',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 24,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 99
  },
  {
    name: 'In Juxtaposition',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/4864560dec3d3b6976f1ab87fa140531f049921d?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '3r3wTlr2JL8KswG3GIJuEJ',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 25,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 100
  },
  {
    name: 'Under London Lights',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/d53580b2797279b7f1560d86e60f4d504376c419?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '2PCg1VljSJRzAIHH7SQuk8',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 26,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 101
  },
  {
    name: 'River Lives',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/51c5a9d9cde2622f0a49a8604b926a3954464c23?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '5myAqdQwjkyXhgZM8wRf2T',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 27,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 102
  },
  {
    name: 'I Have Seen',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/592413d82e26b9ef87271d940c51644d57ba4904?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '4W68TwbtkqyMOlqllheFaO',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 28,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 103
  },
  {
    name: 'Impressions - Movements 1, 2 & 3',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/35856a4d38588a473aea7539fbd5f92a4d36b834?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '6LnJ9CokgaVczVSsnQEgZ3',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 29,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 104
  },
  {
    name: 'A Year And A Day',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/088ade6ba13a8b1cadb56f74328d0c9fa408b520?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '09h4O935FUUIeiqzimWYfT',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 30,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 105
  },
  {
    name: 'This Strange Affair - Reprise',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/aafc400e7bce71bec3790fd26714948c4118ff04?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '3Gl7yxGXiH7WSr29WhNQ0X',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 31,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 106
  },
  {
    name: 'This Is It',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/6a139a98716f4004cd7346357d77458c6d7dc8ee?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '0BZNq58tO9iBOZbDizTXxW',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 32,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 107
  },
  {
    name: 'A Year And A Day - Metamorphosis',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/020ded237d1137bbebc840ff3836cf7f687199af?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '3AM0WW6wFU9MKjggQEBZ5V',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 33,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 108
  },
  {
    name: 'Manah',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/fe390925a72ba51701164b34f3dcf0f8425baedf?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '5WSfaKWezy5uZxd6vAskIP',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 34,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 109
  },
  {
    name: 'Have You Ever Been To Georgia',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/3d3926eaed7a3af2d47d2f107449fed6a2a04e05?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '6p9g6Ycg53ou3fWTC7sy04',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 35,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 110
  },
  {
    name: 'Back Alley Jane',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/752b84ca6776e8270e693e458d40d9572fadd0fc?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '6ciEVPG74VTe7InJsO5cq6',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 36,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 111
  },
  {
    name: 'Nothing Sacred',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/6b055bf1638fe49175773018a61fc36aab196c20?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '2YE9ATgLBcgaarxJBiCmzq',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 37,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 112
  },
  {
    name: 'Sing Me An Old Song',
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/3c20cf084d84bd27b545932b32e0c617b53ca4d3?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '3KsDCw8bpwdkKTKKMKGMTZ',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 38,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 113
  },
  {
    name: "It's So Easy",
    artist_name: 'The Peddlers',
    album_name: 'Suite London',
    release_date: '1972-01-01',
    preview_url: 'https://p.scdn.co/mp3-preview/bb895b0b8e70963d53efde1c3dcba999c9c696a6?cid=43373a1b90854c4289c1373049012fd1',
    images: [
      {
        width: 640,
        height: 640,
        url: 'https://i.scdn.co/image/ab67616d0000b2734a1a52f421b668ee5859575a'
      },
    ],
    spotify_id: '57ovm8YPs63yyJtFuhG7yf',
    album_spotify_id: '3Imu3DUHVauxqHRItdFIVf',
    playlist_name: 'Wessels Dramatic Playlist',
    playlist_spotify_id: '0l571HRfqrxod07b7vMy1e',
    playlist_pos: 39,
    playlist_images: [
      {
        width: 640,
        height: 640,
        url: 'https://mosaic.scdn.co/640/ab67616d0000b2733016bbbbdf0825d3e4dc9aeeab67616d0000b273848936ba27cbea380a7a8d73ab67616d0000b273f20f6e0d61ed79a454d1a57eab67616d0000b273f6c8d14a6c5306b1cc3c3ba9'
      },
    ],
    id: 114
  }
]

class CampaignRestMock {
  public async get (token: string | null, id: number): Promise<RestTrack[]> {
    await sleep(1200)

    return new Promise((resolve) => resolve(mockData))
  }

  public async reload (token: string | null, id: number): Promise<void> {
    await sleep(1200)

    return new Promise((resolve) => resolve())
  }

  async getReloadJobState (token: string|null, id: number): Promise<TracksReloadJobState|null> {
    await sleep(100)

    return {
      type: 'job',
      state: 'completed',
      success: true,
      result: null,
      error: null,
      completed_at: '2021-10-11T16:00:00Z'
    }
  }
}

export default new CampaignRestMock()
